<sc-flex fitHeight vertical stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.title"></sc-dictionary-label>
  </sc-dialog-title>

  <app-transport-info-panel [carrier]="stepperModel.workingData.carrier"
    [identifier]="stepperModel.workingData.identifier" [driver]="stepperModel.workingData.driver"
    [scope]="stepperModel.workingData.transportScope"></app-transport-info-panel>

  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <app-select-action *ngIf="isActionSelection()"></app-select-action>
      <app-detach-truck-and-trailer *ngIf="isDetachTruckAndTrailer()">
      </app-detach-truck-and-trailer>
      <app-detach-truck *ngIf="isDetachTruck()"></app-detach-truck>
      <app-detach-trailer *ngIf="isDetachTrailer()"></app-detach-trailer>
      <app-detach-trailer-semi-trailer-truck
        *ngIf="isDetachTrailerFromSemiTrailerTruck()"></app-detach-trailer-semi-trailer-truck>
      <app-attach-truck *ngIf="isAttachTruck()"></app-attach-truck>
      <app-attach-trailer *ngIf="isAttachTrailer()"></app-attach-trailer>
      <app-select-trailer-swap-target *ngIf="isSelectTrailerSwapTarget()"></app-select-trailer-swap-target>
      <app-trailer-swap-source-details *ngIf="isTrailerSwapSourceDetails()"></app-trailer-swap-source-details>
    </sc-padding>
  </sc-flex-fitting-content>

  <app-service-response [responseMessages]="responseMessages"></app-service-response>

  <sc-actionbar>
    <sc-back-button dictionaryKey="tmc-yard.common.action.previous" (click)="showPreviousStep()" *ngIf="isPreviousStepVisible()"></sc-back-button>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="cancel()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-forward-button dictionaryKey="tmc-yard.common.action.next" primary (click)="showNextStep()" class="confirm-button" [disabled]="!stepCompleted()"
    *ngIf="showNextStepButtonVisible()"></sc-forward-button>
    <sc-button dictionaryKey="tmc-yard.common.action.finish" primary (click)="finish()" *ngIf="showFinishButtonVisible()" class="confirm-button"
    [disabled]="actionRunning || !stepCompleted()"></sc-button>
  </sc-actionbar>

</sc-flex>
